import { Injectable, inject } from "@angular/core";

import { Observable, map } from "rxjs";

import { BackendSettings, SessionResp } from "@models";

import { APP_CONFIG, HttpService } from "./http.service";

interface Balance {
  balance: string;
}

@Injectable({ providedIn: "root" })
export class SessionService extends HttpService {
  protected apiUrl = inject(APP_CONFIG).publicUrl;

  protected domain = "session";

  public create(start_session_token: string): Observable<SessionResp> {
    return this.post<SessionResp>("/create", { start_session_token });
  }

  public settings(): Observable<BackendSettings> {
    return this.post<BackendSettings>("/game_settings", {});
  }

  public balance(): Observable<string> {
    return this.post<Balance>("/get_balance", {}).pipe(map(resp => resp.balance));
  }

  public status(): Observable<void> {
    return this.post<void>("/check_status", {});
  }
}
